"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            groups: null,
            fetching: false,
            more: false,
            suggestions: []
        };
        this.groups = [];
    },
    onMount: function () {
        this.fetchGroups();
    },
    onCreateGroup: function () {
    },
    onOpenGroup: function ({__provider, __spaceId, __groupId}) {
        window.Extensions.run(__provider, {
            action: 'open:group',
            body: {
                spaceId: __spaceId,
                groupId: __groupId
            }
        });
    },
    fetchGroups: async function () {
        try {
            this.state.fetching = true;
            const {error, message, groups, more} = await Request(this.state.more || '/group/list');
            if (error)
                return console.log('Error Fetching Groups: ', message);
            if (more)
                this.state.more = more;
            this.groups = [
                ...this.groups,
                ...groups
            ];
            this.state.groups = this.groups.map(each => {
                const {provider, name, description, status, manager, members, created} = each, memberLen = members.length;
                let memberHTML = '<ul class="list-unstyled users-list m-0 d-flex align-items-center justify-content-start">';
                for (let x = 0; x < members.length; x++) {
                    memberHTML += `<li class="avatar pull-up shadow">
													<img class="rounded-circle border-none" src="${ members[x].photo }" title="${ members[x].name }" style="width:30px;height:30px"/>
												</li>`;
                    if (x == 2)
                        break;
                }
                if (memberLen > 3)
                    memberHTML += `<li class="avatar border theme-bg-transparent pl-50 d-flex align-items-center" style="width:30px;height:30px">
													<p class="text-muted mb-0 font-small-3">+${ memberLen - 3 }</p>
												</li>`;
                memberHTML += `</ul>`;
                return {
                    type: each.private ? '<i class="bx bxs-lock font-medium-5"></i>' : '<i class="bx bx-world font-medium-5"></i>',
                    provider: window.Extensions.meta(provider.type).favicon,
                    name,
                    description: `<span class="text-muted">${ description }</span>`,
                    manager,
                    members: memberHTML,
                    status: status.toCapitalCase(),
                    datetime: formatDate(created.at, 'calendar'),
                    __provider: provider.type.toCapitalCase(),
                    __spaceId: provider.spaceId,
                    __groupId: provider.groupId
                };
            });
            this.setStateDirty('groups');
        } catch (error) {
            if (!this.groups.length)
                this.state.groups = [];
            console.log('Error Fetchint Groups: ', error);
        }
        this.state.fetching = false;
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: profile.first_name + ' ' + profile.last_name,
                subtitle: profile.email,
                status: account.types.join(', ')
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Users/Admin/Groups.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Datatable_template = require("../../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("a440b1"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "btn btn-primary btn-lg m-25"
      },
    marko_node2 = marko_createElement("img", {
        src: "/images/illustration/user-group.png",
        alt: "illustration",
        "class": "w-75"
      }, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "col-12"
      },
    marko_node3 = marko_createElement("br", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "btn btn-primary btn-lg float-right m-25"
      };

const tableFormat = [
	{ key: 'type', label: 'Type' },
	{ key: 'provider', label: 'Provider', type: 'image', col: '1' },
	{ key: 'name', label: 'Name' },
	{ key: 'description', label: 'Description' },
	{ key: 'status', label: 'Status' },
	{ key: 'manager', label: 'Manager' },
	{ key: 'members', label: 'Members' },
	{ key: 'datetime', label: 'Date & Time', wsadapt: { qs: 'd-none', hs: 'd-none' } }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out) {
        if (state.groups === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.groups.length) {
          out.be("div", marko_attrs0, "2", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("h5", null, "5", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Create & Manage User Groups");
                          }
                        }, out, __component, "6");

                      out.ee();

                      out.n(marko_node0, component);

                      out.be("p", marko_attrs1, "8", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Separate, Assign your learners, instructors, ... into different denominations to easely manage them and also to connect people of the same interest for better communication and growth.");
                          }
                        }, out, __component, "9");

                      out.ee();

                      out.n(marko_node1, component);

                      out.be("button", marko_attrs2, "11", component, null, 0, {
                          onclick: __component.d("click", "onCreateGroup", false)
                        });

                      Locale_tag({
                          text: "Create Group"
                        }, out, __component, "12");

                      out.ee();
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    class: "col text-center",
                    renderBody: function(out) {
                      out.n(marko_node2, component);
                    }
                  }, out, __component, "13");
              }
            }, out, __component, "3");

          out.ee();
        } else {
          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    ns: "col-md-5 col-12",
                    qs: "col-md-7 col-12",
                    hs: "col-md-7 col-12",
                    renderBody: function(out) {
                      SearchBar_tag({
                          icon: "bx-group",
                          target: "group",
                          minLength: 3,
                          suggestions: state.suggestions,
                          placeholder: Locale("Find a group")
                        }, out, __component, "17", [
                        [
                          "blur",
                          "onSearchDismiss",
                          false
                        ],
                        [
                          "result",
                          "onSearchResult",
                          false
                        ],
                        [
                          "select",
                          "onSelectSuggestion",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "16");

                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("button", marko_attrs4, "19", component, null, 0, {
                          onclick: __component.d("click", "onCreateGroup", false)
                        });

                      Locale_tag({
                          text: "Add Group"
                        }, out, __component, "20");

                      out.ee();
                    }
                  }, out, __component, "18");

                out.be("div", marko_attrs3, "21", component);

                out.n(marko_node3, component);

                out.n(marko_node4, component);

                Datatable_tag({
                    format: tableFormat,
                    data: state.groups,
                    pagination: 10,
                    stripped: true,
                    class: "w-100"
                  }, out, __component, "24", [
                  [
                    "canload",
                    "fetchGroups",
                    false
                  ],
                  [
                    "select",
                    "onOpenGroup",
                    false
                  ]
                ]);

                out.ee();
              }
            }, out, __component, "15");
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
